import React from "react";
import { Box, Tooltip } from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { colors, fontSize } from "theme/defaultStyle";

interface MissingFieldWarningProps {
  title: string;
}

const MissingFieldWarning = ({ title }: MissingFieldWarningProps) => (
  <Tooltip
    arrow
    placement="top"
    title={title}
    componentsProps={{
      tooltip: { sx: { maxWidth: "none", whiteSpace: "nowrap" } },
    }}
  >
    <Box component="span" sx={{ display: "inline-flex", alignItems: "center" }}>
      <WarningAmberOutlinedIcon
        sx={{ fontSize: fontSize.xlarge1, color: colors.red01 }}
      />
    </Box>
  </Tooltip>
);

export default MissingFieldWarning;
